/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyFreeNode = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyFreeNode model module.
   * @module model/StrategyFreeNode
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyFreeNode</code>.
   * @alias module:model/StrategyFreeNode
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>StrategyFreeNode</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyFreeNode} obj Optional instance to populate.
   * @return {module:model/StrategyFreeNode} The populated <code>StrategyFreeNode</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AddedBy')) {
        obj['AddedBy'] = ApiClient.convertToType(data['AddedBy'], 'Integer');
      }
      if (data.hasOwnProperty('Added')) {
        obj['Added'] = ApiClient.convertToType(data['Added'], 'Date');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ParentDescriptionID')) {
        obj['ParentDescriptionID'] = ApiClient.convertToType(data['ParentDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('ParentGoalID')) {
        obj['ParentGoalID'] = ApiClient.convertToType(data['ParentGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('ParentNodeID')) {
        obj['ParentNodeID'] = ApiClient.convertToType(data['ParentNodeID'], 'Integer');
      }
      if (data.hasOwnProperty('DashboardPageID')) {
        obj['DashboardPageID'] = ApiClient.convertToType(data['DashboardPageID'], 'Integer');
      }
      if (data.hasOwnProperty('IsSelection')) {
        obj['IsSelection'] = ApiClient.convertToType(data['IsSelection'], 'Boolean');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ParentMilestoneID')) {
        obj['ParentMilestoneID'] = ApiClient.convertToType(data['ParentMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('ParentProgramID')) {
        obj['ParentProgramID'] = ApiClient.convertToType(data['ParentProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('IsMemo')) {
        obj['IsMemo'] = ApiClient.convertToType(data['IsMemo'], 'Boolean');
      }
      if (data.hasOwnProperty('IsAttachment')) {
        obj['IsAttachment'] = ApiClient.convertToType(data['IsAttachment'], 'Boolean');
      }
      if (data.hasOwnProperty('TargetURL')) {
        obj['TargetURL'] = ApiClient.convertToType(data['TargetURL'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} AddedBy
   * @default 0
   */
  exports.prototype['AddedBy'] = 0;
  /**
   * @member {Date} Added
   */
  exports.prototype['Added'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ParentDescriptionID
   */
  exports.prototype['ParentDescriptionID'] = undefined;
  /**
   * @member {Integer} ParentGoalID
   */
  exports.prototype['ParentGoalID'] = undefined;
  /**
   * @member {Integer} ParentNodeID
   */
  exports.prototype['ParentNodeID'] = undefined;
  /**
   * @member {Integer} DashboardPageID
   */
  exports.prototype['DashboardPageID'] = undefined;
  /**
   * @member {Boolean} IsSelection
   * @default false
   */
  exports.prototype['IsSelection'] = false;
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} ParentMilestoneID
   */
  exports.prototype['ParentMilestoneID'] = undefined;
  /**
   * @member {Integer} ParentProgramID
   */
  exports.prototype['ParentProgramID'] = undefined;
  /**
   * @member {Boolean} IsMemo
   * @default false
   */
  exports.prototype['IsMemo'] = false;
  /**
   * @member {Boolean} IsAttachment
   * @default false
   */
  exports.prototype['IsAttachment'] = false;
  /**
   * @member {String} TargetURL
   * @default ''
   */
  exports.prototype['TargetURL'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


